var map = {
	"./versionA/naming/test-blur.jpg": 133,
	"./versionA/naming/test-croc.jpg": 134,
	"./versionA/naming/test-fork.jpg": 135,
	"./versionA/naming/test-pen.jpg": 136,
	"./versionA/naming/test-phone.jpg": 137,
	"./versionA/naming/test-pineapple.jpg": 138,
	"./versionA/naming/test.jpg": 139,
	"./versionA/picID/test.png": 78,
	"./versionB/naming/test-blur.jpg": 140,
	"./versionB/naming/test-butterfly.jpg": 141,
	"./versionB/naming/test-giraffe.jpg": 142,
	"./versionB/naming/test-knife.jpg": 143,
	"./versionB/naming/test-pencil.jpg": 144,
	"./versionB/naming/test-tv.jpg": 145,
	"./versionB/naming/test.jpg": 146,
	"./versionB/picID/test.png": 79
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 132;